const api = {}
// 测试
// api.grUrl = 'http://192.168.0.10:4333'

// 正式
api.grUrl = 'http://colorxxcolor.jp/kara'

api.imgUrl = 'http://colorxxcolor.jp'
// api.imgUrl = 'http://test.52atr.com:8000/static/'
export default api



// WEBPACK FOOTER //
// ./src/utils/api.js